import { SITE_NAME, SITE_URL } from "../../lib/seoConfig";

// Reusable JSON-LD structured data generators. Only schema that accurately
// represents real ServiceGuru Pro content — no fake reviews/ratings/prices.

export function organizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: SITE_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/servicegurupro-logo.png`,
    description:
      "ServiceGuru Pro is a home service CRM and field service management platform with AI voice agents for HVAC, plumbing, electrical, pool service, landscaping, roofing and other contractor businesses.",
  };
}

export function softwareApplicationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: SITE_NAME,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    description:
      "Home service CRM and field service management software with dispatching, scheduling, estimates, invoicing, payments, payroll, and AI voice agents.",
    url: SITE_URL,
  };
}

export function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: SITE_NAME,
    url: SITE_URL,
  };
}

/** items: [{ name, path }] in breadcrumb order, home first */
export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${SITE_URL}${item.path}`,
    })),
  };
}

/** faqs: [{ question, answer }] */
export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.answer,
      },
    })),
  };
}
